import styles from "./VodFooter.module.scss"

import React, { useCallback, useState } from "react"
import { useParams } from "react-router-dom"

import CallCenter from "@shared/components/layerPopups/CallCenter"
import { WOWNET_CONTENT } from "@shared/constants"

function VodFooter() {
  const { streamerName } = useParams<{ streamerName?: string }>()
  const [isCallCenter, setIsCallCenter] = useState<boolean>(false)

  const handleIsCallCenter = useCallback((_isCallCenter: boolean) => {
    setIsCallCenter(_isCallCenter)
  }, [])

  return (
    <article className="botB">
      <div className={`iframeB ${styles.bgcolor}`}>
        <iframe
          title="알림"
          className={styles.headerSize}
          src={`${WOWNET_CONTENT.header}?analid=${streamerName}`}
        />
      </div>
      <div className="csB">
        <a
          href="#!"
          className="btn"
          title="고객센터안내"
          onClick={(e) => {
            e.preventDefault()
            setIsCallCenter(!isCallCenter)
          }}
        >
          <i>-</i>고객센터안내
        </a>
        {isCallCenter && <CallCenter handleIsCallCenter={handleIsCallCenter} />}
      </div>
    </article>
  )
}

export default VodFooter
